"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContext = void 0;
var React = __importStar(require("react"));
var Typography_1 = require("../Typography/Typography");
var Button_1 = __importDefault(require("../Button/Button"));
var Portal_1 = __importDefault(require("../Portal/Portal"));
var ModalBackdrop_1 = __importDefault(require("./ModalBackdrop"));
var ModalBody_1 = __importDefault(require("./ModalBody"));
var ModalCard_1 = __importDefault(require("./ModalCard"));
var ModalClose_1 = __importDefault(require("./ModalClose"));
var ModalContent_1 = __importDefault(require("./ModalContent"));
var ModalFooterContainer_1 = __importDefault(require("./ModalFooterContainer"));
var ModalHeader_1 = __importDefault(require("./ModalHeader"));
var ModalWrapper_1 = __importDefault(require("./ModalWrapper"));
exports.ModalContext = React.createContext(null);
var Modal = function (_a) {
    var background = _a.background, border = _a.border, children = _a.children, closeButtonText = _a.closeButtonText, _b = _a.closeColor, closeColor = _b === void 0 ? 'BRAND_BLACK' : _b, closeOutside = _a.closeOutside, loader = _a.loader, _c = _a.minimal, minimal = _c === void 0 ? false : _c, onClose = _a.onClose, _d = _a.size, size = _d === void 0 ? 'sm' : _d, title = _a.title;
    var footerContainerRef = React.useRef(null);
    var fallback = loader || React.createElement("div", null, 'general.loading');
    return (React.createElement(Portal_1.default, null,
        React.createElement(exports.ModalContext.Provider, { value: footerContainerRef },
            React.createElement(ModalBackdrop_1.default, null),
            React.createElement(ModalWrapper_1.default, { tabIndex: -1 },
                React.createElement(ModalContent_1.default, { "$size": size },
                    React.createElement(ModalCard_1.default, { minimal: minimal, background: background, border: border },
                        minimal ? (React.createElement(ModalClose_1.default, { color: closeColor, onClick: onClose, minimal: true, closeOutside: closeOutside })) : (React.createElement(ModalHeader_1.default, null,
                            React.createElement(Typography_1.H2, null, title),
                            React.createElement(ModalClose_1.default, { color: closeColor, onClick: onClose, closeOutside: closeOutside }))),
                        React.createElement(ModalBody_1.default, { minimal: minimal },
                            React.createElement(React.Suspense, { fallback: fallback }, children)),
                        !minimal && (React.createElement(ModalFooterContainer_1.default, { ref: footerContainerRef }, closeButtonText && (React.createElement(Button_1.default, { xs: true, secondary: true, onClick: onClose }, closeButtonText))))))))));
};
exports.default = Modal;
